import styled, { css } from "../../__compat__/styled-components/main.entry.mjs.mjs";
import { injectTypography } from "../../utils/injectTypography.mjs.mjs";
import { injectOSXFontSmoothing } from "../../utils/injectOSXFontSmoothing.mjs.mjs";
const getTagPadding = (props) => props.variant === 'readonly' ? getReadonlyPadding(props) : '6px 12px 6px 12px';
const getReadonlyPadding = (props) => props.size === 'small' ? '2px 8px 2px 8px' : '4px 12px 4px 12px';
const getTagHeight = (props) => props.variant === 'selectable' ? getSelectableHeight(props) : 'inherit';
const getSelectableHeight = (props) => props.size === 'large' ? '36px' : '32px';
export const iconSizes = {
    small: 10,
    large: 14,
};
export const buttonSizes = {
    small: 24,
    large: 24,
};
// The spec defines a 16px and 20px button box, but in order to make the target area
// a decent target size (24px) some padding and negative margin are used to keep
// the design correct.
// There's also some extra adjustments done to align the X with the text baseline.
const getButtonBox = (props) => {
    return css `
    margin: ${props.size === 'small'
        ? '-7px -12px -7px -5px'
        : '-7px -12px -7px -5px'};
    padding: ${(buttonSizes[props.size] - iconSizes[props.size]) / 2}px;
  `;
};
export const StyledTag = styled.span.withConfig({ displayName: "auir-611444a-StyledTag", componentId: "auir-611444a-e37vgp" }) `
  padding: ${(props) => getTagPadding(props)};
  display: inline-flex;
  align-items: center;
  text-align: start;
  grid-column-gap: var(${(props) => props.theme.responsive.spacing.xs});
  background-color: var(${(props) => props.theme.colors.ui.highlight.tertiary});
  min-height: ${(props) => getTagHeight(props)};
  color: var(${(props) => props.theme.colors.ui.secondary});
  ${(props) => injectTypography(props, props.size === 'small' ? 'copy2' : 'copy1')}
  ${(props) => injectOSXFontSmoothing(props.size !== 'small')}
  box-sizing: border-box;
  box-shadow: inset 0 0 0 1px
    var(
      ${(props) => props.variant === 'selectable' &&
    props.theme.colors.interaction.tertiary.default}
    );
  border-radius: 0;
  cursor: var(${(props) => props.variant === 'selectable' && 'pointer'});
  &:disabled {
    cursor: not-allowed;
  }
`;
export const StyledTagButton = styled.button.withConfig({ displayName: "auir-611444a-StyledTagButton", componentId: "auir-611444a-lbgfra" }) `
  padding: ${(props) => getTagPadding(props)};
  display: flex;
  align-items: center;
  grid-column-gap: var(${(props) => props.theme.responsive.spacing.xs});
  border: none;
  box-sizing: border-box;
  box-shadow: inset 0 0 0 1px
    var(${(props) => props.theme.colors.interaction.tertiary.default});
  border-radius: 0;
  cursor: pointer;
  &:disabled {
    cursor: not-allowed;
  }

  background: none;
  cursor: pointer;
  &:hover {
    background-color: var(
      ${(props) => props.theme.colors.interaction.tertiary.default}
    );
  }
  &:focus {
    background-color: var(
      ${(props) => props.theme.colors.interaction.tertiary.default}
    );
  }
  &:selected {
    background-color: var(
      ${(props) => props.theme.colors.interaction.tertiary.default}
    );
  }
  &[aria-checked='true'] {
    background-color: var(
      ${(props) => props.theme.colors.interaction.tertiary.default}
    );
  }
  &[aria-disabled='true'] {
    color: var(${(props) => props.theme.colors.interaction.label.disabled});
    border: var(${(props) => props.theme.colors.interaction.tertiary.disabled});
    cursor: not-allowed;
  }
  text-align: start;
  color: var(${(props) => props.theme.colors.interaction.label.default});
  ${(props) => injectTypography(props, props.size === 'small' ? 'copy2' : 'copy1')}
  ${(props) => injectOSXFontSmoothing(props.size !== 'small')}
`;
export const StyledTagCloseButton = styled.button.withConfig({ displayName: "auir-611444a-StyledTagCloseButton", componentId: "auir-611444a-15eue10" }) `
  display: inline-flex;
  align-items: center;
  ${() => getButtonBox}
  color: var(${(props) => props.theme.colors.interaction.secondary.default});

  background-color: transparent;
  border: none;
  border-radius: 0;
  cursor: pointer;

  appearance: none;

  &:hover {
    color: var(${(props) => props.theme.colors.interaction.secondary.hover});
  }

  &:focus {
    color: var(${(props) => props.theme.colors.interaction.secondary.focus});
  }
`;
//# sourceMappingURL=Tag.styles.mjs.mjs.map